import cruise1 from "./GRN_0093.webp";
import cruise2 from "./20240518_092429.webp";
import cruise3 from "./20240908_095405.webp";
import cruise4 from "./[Group 7].webp";
import cruise5 from "./20240922_093124.webp";
import cruise6 from "./Przystan czorsztyn dron_42.webp";
import cruise7 from "./cruise.webp";
import cruise8 from "./IMG_0263.webp";
import cruise9 from "./1.webp";
import cruise10 from "./20240709_144529.webp";
import cruise11 from "./Przystan czorsztyn dron_50.webp";
import cruise12 from "./IMG_0508.webp";

export const cruiseImages = [
    { src: cruise1, altKey: "1" },
    { src: cruise2, altKey: "2" },
    { src: cruise3, altKey: "3" },
    { src: cruise4, altKey: "4" },
    { src: cruise5, altKey: "5" },
    { src: cruise6, altKey: "6" },
    { src: cruise7, altKey: "7" },
    { src: cruise8, altKey: "8" },
    { src: cruise9, altKey: "9" },
    { src: cruise10, altKey: "10" },
    { src: cruise11, altKey: "11" },
    { src: cruise12, altKey: "12" }
];